import React from 'react'
import styled from '@emotion/styled'
import HeadingBorder from 'src/components/atoms/HeadingBorder'
import ContentsWrapper from 'src/components/atoms/wrappers/ContentsWrapper'
import { BreakPoint } from 'src/components/shared/CssValues'
import HeadLine from 'src/components/atoms/HeadLine'
import { Typography } from 'src/components/atoms/Typography'
// images
import ceo from 'src/images/company/takada.png'
import coo from 'src/images/company/hashimoto.png'
import cto from 'src/images/company/yamamoto.png'
import twitterLogo from 'src/images/company/twitter-logo.svg'
import noteLogo from 'src/images/company/note-logo.svg'

const CompanyMembers = () => {
  return (
    <ContentsWrapper>
      <Contents>
        <HeadingBorder heading="BOARD MEMBERS" />
        <HeadLine>経営陣</HeadLine>
        <MemberList>
          <MemberListItem>
            <MemberImage src={ceo} />
            <MemberName as="p">高田優哉</MemberName>
            <MemberPosition as="p">共同創業者 / 代表取締役CEO</MemberPosition>
            <MemberInformation as="p">
              パリ農工大学留学を経て東京大学農学部卒業。卒業後ボストンコンサルティンググループに入社し、東京、ロサンゼルス、上海オフィスで戦略コンサルティング業務に従事。リードコンサルタントとして活躍後退職し、コミューン株式会社を共同創業。
            </MemberInformation>
            <SNSLinkLine>
              <TwitterLink linkTo="https://twitter.com/belgrou" />
              <NoteLink linkTo="https://note.com/yuya_takada" />
            </SNSLinkLine>
          </MemberListItem>
          <MemberListItem>
            <MemberImage src={coo} />
            <MemberName as="p">橋本翔太</MemberName>
            <MemberPosition as="p">共同創業者 / 取締役CPO</MemberPosition>
            <MemberInformation as="p">
              ストックホルム経済大学留学を経て、東京大学経済学部卒業。卒業後Google
              Japanに入社し、プロダクトマーケティング業務に従事した後、アメリカ本社に転籍。広告製品の新規顧客ダイレクトマーケティングをリード。退職後帰国し、コミューン株式会社を共同創業。
            </MemberInformation>
            <SNSLinkLine>
              <TwitterLink linkTo="https://twitter.com/shotahash" />
              <NoteLink linkTo="https://note.com/89shota" />
            </SNSLinkLine>
          </MemberListItem>
          <MemberListItem>
            <MemberImage src={cto} />
            <MemberName as="p">山本晃大</MemberName>
            <MemberPosition as="p">取締役CTO</MemberPosition>
            <MemberInformation as="p">
              学業の傍らフリーランスエンジニアとして活躍し、東京大学経済学部卒業。新卒で大手ゲーム会社にエンジニアとして就職し、フルスタックエンジニアとして活躍。また、ハッカソン等で数々の受賞歴を保有。コミューン株式会社参画後、サービスの開発全般をリード。
            </MemberInformation>
            <SNSLinkLine>
              <TwitterLink linkTo="https://twitter.com/ay_at_commmune" />
            </SNSLinkLine>
          </MemberListItem>
        </MemberList>
      </Contents>
    </ContentsWrapper>
  )
}

const Contents = styled.div`
  margin: 120px 0;
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    margin: 80px 0;
  }
`

const MemberList = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    flex-direction: column;
  }
`

const MemberListItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  width: 26.262%;
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    width: 100%;
    &:not(:last-of-type) {
      margin-bottom: 20px;
    }
  }
`

const MemberImage = styled.img`
  width: 80%;
  text-align: center;
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    margin-top: 40px;
    text-align: center;
  }
`

const MemberName = styled(Typography)`
  width: 100%;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: 1.28px;
  text-align: center;
  color: #333333;
  margin-top: 30px;
`

const MemberPosition = styled(Typography)`
  width: 100%;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.29;
  letter-spacing: 1.12px;
  text-align: center;
  color: #333333;
`

const MemberInformation = styled(Typography)`
  width: 100%;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: 1.04px;
  text-align: left;
  color: #333333;
  margin-top: 22px;
`

const SNSLinkLine = styled.div`
  display: flex;
  justify-content: center;
  height: 50px;
  margin: 22px 0 0;
`

const NoteLink = ({ linkTo }) => {
  return <LogoLink img={noteLogo} linkTo={linkTo} />
}

const TwitterLink = ({ linkTo }) => {
  return <LogoLink img={twitterLogo} linkTo={linkTo} />
}

const LogoLink = ({ img, linkTo }) => {
  const OuterLink = styled.a`
    height: 100%;
    margin: 0 10px;
  `

  const Logo = styled.img`
    height: 100%;
  `

  return (
    <OuterLink href={linkTo} target="_blank">
      <Logo src={img}></Logo>
    </OuterLink>
  )
}

export default CompanyMembers
